import React from 'react';
import { Edit } from 'react-admin';
import PageForm from './PageForm';

export const PageEdit = () => (
  <Edit>
    <PageForm />
  </Edit>
);

export default PageEdit;
